import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Checkbox } from 'antd';
import { WorksheetModel } from '../../models';
import { useAppStore } from '../../stores';
import WorksheetActionsDropdown from './WorksheetActionsDropdown';
import './WorksheetCard.less';

interface Props {
    worksheet: WorksheetModel;
}

const WorksheetCard: React.FC<Props> = ({ worksheet }) => {
    const appStore = useAppStore();

    const { worksheetsStore, worksheetsSubmissionStore, sessionId, packageId, documentVisualStore } = appStore;

    const handleCardClick = () => {
        worksheetsStore.selectWorksheet(worksheet);

        if (!worksheet.isSelected) {
            return;
        }

        const page = window.document.getElementById(`${sessionId}-${packageId}-${worksheet.startPage - 1}`);

        if (page) {
            page.scrollIntoView({ block: 'start' });
        }

        documentVisualStore.setCurrentPage(worksheet.startPage - 1);
    };

    const renderPagesLabel = () => {
        if (!worksheet.startPage || !worksheet.endPage) {
            return '';
        }

        if (worksheet.startPage === worksheet.endPage) {
            return `P${worksheet.startPage}`;
        }

        return `P${worksheet.startPage}-${worksheet.endPage}`;
    };

    const renderDot = () => {
        if (worksheet.hasValidationError) {
            return <div className="worksheet-card-dot red" />;
        }

        if (worksheet.hasChanges && !worksheet.isSuccessful) {
            return <div className="worksheet-card-dot blue" />;
        }

        return null;
    };

    const worksheetStatusClassName = worksheet.status.toLowerCase();

    const getWorksheetBusinessIdClassName = () => {
        let className = `worksheet-business-id-label ${worksheetStatusClassName}`;

        if (worksheet.businessId) {
            className += ' has-business-id';
        }

        return className;
    };

    const handleWorksheetSelectionChange = () => {
        worksheet.setIsSelectedForSubmission(!worksheet.isSelectedForSubmission);
        worksheetsSubmissionStore.updateSelectAllState();
    };

    return (
        <div className={`worksheet-card-container ${worksheet.isSelected ? 'selected' : ''}`} onClick={handleCardClick}>
            <div className="submission-checkbox-container">
                {worksheetsSubmissionStore.selectiveModeEnabled && !worksheet.isLocked && (
                    <Checkbox
                        checked={worksheet.isSelectedForSubmission}
                        onClick={e => e.stopPropagation()}
                        onChange={handleWorksheetSelectionChange}
                    />
                )}
            </div>

            <div className="worksheet-summary-container">
                <div className="summary-row">
                    <span className={`worksheet-status-label ${worksheetStatusClassName}`}>{worksheet.status}</span>
                    {renderDot()}
                </div>

                <div className="summary-row">
                    <span className={getWorksheetBusinessIdClassName()}>
                        {worksheet.businessId ? `${worksheet.businessId}` : 'Business: – EMPTY –'}
                    </span>
                    <WorksheetActionsDropdown worksheet={worksheet} />
                </div>

                <div className="summary-row">
                    <span className="worksheet-net-due-label">Net Due: {worksheet.netDueLabel}</span>
                    <span className="worksheet-pages-label">{renderPagesLabel()}</span>
                </div>
            </div>
        </div>
    );
};

export default observer(WorksheetCard);
